import BaseAPI from "../base";
import { getStorageExpire, setStorageExpire } from "@/utils/utils";
import { CONFIG_STORAGE } from "@/constants/storage";
import { getUserInfoByCode } from "@/models/selfCardUser";

class SelfCardService extends BaseAPI {
  selfCardPost({ url, data = {}, headers = {} }) {
    return this.post({
      url,
      data,
      headers 
    }).catch(async(error) => {
      if (error.Status === 401) {
        const user = await getUserInfoByCode();
        if (Object.keys(user).length > 0) {
          setStorageExpire('dd-self-card-user', user, 60 * 24);
          headers.Authorization = `Bearer ${this.getToken()}`
        }
        return this.selfCardPost({ url, data, headers })
      }
      return Promise.reject(error);
    });
  }
  selfCardGet({ url, data = {}, headers = {} }) {
    return this.get({
      url,
      data,
      headers 
    }).catch(async(error) => {
      if (error.Status === 401) {
        const user = await getUserInfoByCode();
        if (Object.keys(user).length > 0) {
          setStorageExpire('dd-self-card-user', user, 60 * 24);
          headers.Authorization = `Bearer ${this.getToken()}`
        }
        return this.selfCardGet({ url, data, headers })
      }
    });
  }
  getToken() {
    const userInfo = getStorageExpire('dd-self-card-user')
    return userInfo.access_token || ''
  }
  // 通过钉钉 code 获取 token
  getUserInfo(params) {
    return this.selfCardPost({
      url: `${process.env.VUE_APP_SELFCARD_APIBASEURL}/SelfCard/DingAuth`,
      data: params
    });
  }
  // 获取渠道
  getChannels(params) {
    return this.selfCardPost({
      url: `${process.env.VUE_APP_SELFCARD_APIBASEURL}/SelfCard/CardChannelList`,
      data: params,
      headers: {
        Authorization: `Bearer ${this.getToken()}`
      }
    });
  }
  // 获取卡版本
  getCardVersions(params) {
    return this.selfCardPost({
      url: `${process.env.VUE_APP_SELFCARD_APIBASEURL}/SelfCard/CardVersionList`,
      data: params,
      headers: {
        Authorization: `Bearer ${this.getToken()}`
      }
    });
  }
  // 获取卡类型
  getCardTypes(params) {
    return this.selfCardPost({
      url: `${process.env.VUE_APP_SELFCARD_APIBASEURL}/SelfCard/CardTypeList`,
      data: params,
      headers: {
        Authorization: `Bearer ${this.getToken()}`
      }
    });
  }
  // 获取服务
  getServices(params) {
    return this.selfCardPost({
      url: `${process.env.VUE_APP_SELFCARD_APIBASEURL}/SelfCard/CardTypeServiceSearch`,
      data: params,
      headers: {
        Authorization: `Bearer ${this.getToken()}`
      }
    });
  }
  // 获取单价
  getUnitPrice(params) {
    return this.selfCardPost({
      url: `${process.env.VUE_APP_SELFCARD_APIBASEURL}/SelfCard/CardTypePriceSearch`,
      data: params,
      headers: {
        Authorization: `Bearer ${this.getToken()}`
      }
    });
  }
  // 上传文件
  uploadFileOss(params) {
    return this.selfCardPost({
      url: `${process.env.VUE_APP_SELFCARD_APIBASEURL}/SelfCard/FileOss`,
      data: params,
      headers: {
        Authorization: `Bearer ${this.getToken()}`
      }
    });
  }
  // 提交自助卡 Form
  recordEdit(params) {
    return this.selfCardPost({
      url: `${process.env.VUE_APP_SELFCARD_APIBASEURL}/SelfCard/RecordEdit_Web`,
      data: params,
      headers: {
        Authorization: `Bearer ${this.getToken()}`
      }
    });
  }
  // 提交自助卡申请以后, 然后后台执行生成 CardsExcel 的功能
  createCardsExcel(params) {
    return this.selfCardPost({
      url: `${process.env.VUE_APP_SELFCARD_APIBASEURL}/SelfCard/RecordCreateExcel_Web`,
      data: params,
      headers: {
        Authorization: `Bearer ${this.getToken()}`
      }
    });
  }
  // 成功页面检验卡Excel是否生成
  getSelfCardStatus() {
    return this.selfCardPost({
      url: `${process.env.VUE_APP_SELFCARD_APIBASEURL}/SelfCard/CardChannelList`,
      headers: {
        Authorization: `Bearer ${this.getToken()}`
      }
    });
  }
  // 获取自助卡列表
  selfCardList(params) {
    return this.selfCardPost({
      url: `${process.env.VUE_APP_SELFCARD_APIBASEURL}/SelfCard/RecordList_Web`,
      data: params,
      headers: {
        Authorization: `Bearer ${this.getToken()}`
      }
    });
  }
  // 获取自助卡详情
  selfCardDetail(params) {
    return this.selfCardPost({
      url: `${process.env.VUE_APP_SELFCARD_APIBASEURL}/SelfCard/RecordInfo_Web`,
      data: params,
      headers: {
        Authorization: `Bearer ${this.getToken()}`
      }
    });
  }
  // 查询剩余未支付金额
  getRecordNotPay(params) {
    return this.selfCardPost({
      url: `${process.env.VUE_APP_SELFCARD_APIBASEURL}/SelfCard/RecordNotPay_Web`,
      data: params,
      headers: {
        Authorization: `Bearer ${this.getToken()}`
      }
    });
  }
  // 新增付款信息
  payRecordAdd(params) {
    return this.selfCardPost({
      url: `${process.env.VUE_APP_SELFCARD_APIBASEURL}/SelfCard/RecordPayEdit_Web`,
      data: params,
      headers: {
        Authorization: `Bearer ${this.getToken()}`
      }
    });
  }
  // 支付记录列表
  getPayRecordList(params) {
    return this.selfCardPost({
      url: `${process.env.VUE_APP_SELFCARD_APIBASEURL}/SelfCard/RecordPayList_Web`,
      data: params,
      headers: {
        Authorization: `Bearer ${this.getToken()}`
      }
    });
  }
  // 获取相关枚举
  selfCardEnums() {
    return new Promise((resolve) => {
      let result = getStorageExpire(CONFIG_STORAGE.SELFCARD_ENUM);
      if (result && result.version >= CONFIG_STORAGE.currentVersion) {
        resolve(result);
      } else {
        this.selfCardGet({
          url: `${process.env.VUE_APP_SELFCARD_APIBASEURL}/SelfCard/DictList`,
          headers: {
            Authorization: `Bearer ${this.getToken()}`
          }
        }).then((res) => {
          let enums = {}
          if (res.length > 0) {
            res.forEach((item) => {
              if (item.name === 'card_version') {
                enums[item.name] = item.dicts
              } else {
                enums[item.name] = {}
                if (item.dicts.length > 0) {
                  item.dicts.forEach((dict) => {
                    enums[item.name][dict.key] = dict.value
                  })
                }
              }
            })
          }
          setStorageExpire(
            CONFIG_STORAGE.SELFCARD_ENUM,
            {
              ...enums,
              version: CONFIG_STORAGE.currentVersion,
            },
            60 * 24
          );
          resolve(enums);
        });
      }
    });
  }
}

export default new SelfCardService();
